'use strict';

/* Main Controller */
import SocialBarLoader from "../../SocialBar/SocialBarLoader";
import LinkTracking from "../../fsUtils/TrackingUtils";
import videoUtils from '../../fsUtils/videoUtils';

angular.module('storyApp').controller('StoryCtrl',
    ['$scope', '$rootScope', '$location', '$sce', 'threeThingsAPI', 'trackingUtils', 'cqArticleService', 'storyScroll', 'storyInView', 'storyEvents','threeThingEvents','metaDataFactory', 'parselyService', '$window',
        function($scope, $rootScope, $location, $sce, threeThingsAPI, trackingUtils, cqArticleService, storyScroll, storyInView, storyEvents, threeThingEvents, metaDataFactory, parselyService, $window) {

            var loc = location;

            //original story setup
            var originalPath = loc.pathname + loc.search.substring();

            //load meta data for original story
            var originalMetadata = metaDataFactory.getMainStoryMetaData();

            var isThreeThingsEnabled = document.querySelector('.three-things');

            var isRegional = document.querySelector('.is-regional');

            let path = isRegional ? '/' + location.pathname.split('/')[1] : '';

            /**
             * onPageChanged needs to run for right rail pinning and the original metadata
             * @param Number storyIndex - 1: the orignal story
             * @param Object metaData - originalMetadata for main story's meta tags, ads and analytics
             * @param Boolean onPageload - true to indicate if onPageChanged is called on pageload
             **/
            storyEvents.onPageChanged(1, originalMetadata, true);
            
            $location.state({ storyIndex: 0 });

            $scope.threeThings = [];

            $scope.relatedContent = [];

            $scope.storyViewIndex = 0;

            //renders the section related to the post page
            function renderPage() {
                //fetch and render the first story on the three things on page load
                cqArticleService.fetchSectionFront( location.origin + path + "?scrollToHome=true").then(function(){
                    cqArticleService.renderSectionFront(0);
                });
            }


            cqArticleService.onRenderArticle = function(relatedIndex, articleContent){
                $scope.relatedContent[relatedIndex] = $sce.trustAsHtml(articleContent);
            };
        
            //set up home 
            if( isThreeThingsEnabled ) {

                //setup 3 things from ng-init
                $scope.getThreeThings = function(apiUrl) {

                    try {
                        //calling threeThingsAPI.getThreeThings when 3things apiUrl is returned from backend
                        if (apiUrl) {
                            threeThingsAPI.getThreeThings(apiUrl).then(function(data) {

                                //show 3 things on the left
                                $scope.threeThings = data;

                                for (let i = 0, len = data.length; i < len; i++) {
                                    //add data returned from 3 things to articles array
                                    //data[i].url will be used as browser url
                                    //data[i].articleUrl will be used when fetching the article content
                                    cqArticleService.addArticle(data[i].url, data[i].articleUrl);
                                }

                                //fetch and render the first story on the three things on page load
                                cqArticleService.fetchArticle(0).then(function(){
                                    cqArticleService.renderArticle(0);
                                });

                            });

                        }
                        
                    } catch(e) {

                        console.log("something went wrong -",e);
                    }

                };
            } else {
                    //adding this if block to test rendering content on scroll
                    if( document.body.classList.contains('no-crawl') ) {
                        angular.element($window).bind('scroll', function() { 
                            renderPage();
                        });
                    } else {
                        renderPage();
                    }
            }
            $scope.onclick = function($event, relatedIndex) {

                // Creating and triggering the Click event to Relevancy Engine

                trackingUtils.sendThreeThingsClickedData($scope.threeThings, relatedIndex);

                //related index will be 0-3 for four stories
                var elId = 'story-' + (relatedIndex + 2),
                    thisClickedStoryFetched =  cqArticleService.articles[relatedIndex].isFetched;

                // if thisClickedStoryFetched is false, that means users click on either third or last story on the 3things
                if(!thisClickedStoryFetched) {

                    // Load Social Bars for the new rendered story
                    SocialBarLoader();
                    // FSCOM-12270 - set "More Videos" link parse.ly tracking 
                    LinkTracking.setLinkTracking(document.querySelectorAll('.more-video > a.fs-more-btn'),'parsely',{
                        'utm_campaign'  : 'more_videos',
                        'utm_medium'    : 'fscom',
                        'utm_content'   : 'morelink'
                    });
                    LinkTracking.setLinkTracking(document.querySelectorAll('.fs-more-content > .fs-card-container > .fs-card'),'parsely',{
                        'utm_campaign'  : 'more_videos',
                        'utm_medium'    : 'fscom',
                        'utm_content'   : 'gallerytile'
                    });
                    videoUtils.setVideoDetailsToggle();

                    /*
                     * if relatedIndex is equal to 2, that means users click on last story on the 3things.
                     * We will fetch and render third story first, and then fetch and render the last story.
                     */
                    if(relatedIndex === 2 ) {
                        cqArticleService.fetchArticle(1).then(function(){
                            cqArticleService.renderArticle(1);

                            cqArticleService.fetchArticle(2).then(function(){

                                cqArticleService.renderArticle(2);

                                /*
                                 * after render last story, check if third story is rendered completely.
                                 * if third story is rendered completely, scroll to last story
                                 */
                                storyEvents.monitorElmOnLoad( document.getElementById('story-3'), function() {

                                    storyScroll.jumpToElement(elId, 300, true)
                                });

                            });

                        });

                    } else {

                        /*
                         * if relatedIndex is not equal to 2, that means users click on the third story on the 3things.
                         * We will fetch and render third story first
                         */
                        cqArticleService.fetchArticle(1).then(function(){

                            cqArticleService.renderArticle(1);

                            /*
                             * check if third story is rendered completely.
                             * if third story is rendered completely, scroll to third story
                             */
                            storyEvents.monitorElmOnLoad( document.getElementById('story-3'), function() {

                                storyScroll.jumpToElement(elId, 100, true)
                            });
                        });

                    }

                } else {

                    //otherwise, scrollTo that element immediately since the story has been rendered
                    storyScroll.jumpToElement(elId, 0, true);
                }
                // track click
                if (relatedIndex && relatedIndex > -1) {
                    parselyService.passingUrl(cqArticleService.getUrl(relatedIndex), relatedIndex + 1 ,'thumb');
                }

                $event.preventDefault();
            };

            //storyInView.onChange is triggered on storyInView.goto method when the storyViewIndex is changed
            storyInView.onChange = function(storyViewIndex) {

                var newUrl;

                $scope.storyViewIndex = storyViewIndex;

                //apply updates if it is not the original story
                if(storyViewIndex > 0) {

                    //if scroll to home is active, check if it's a regional page if not, then sure existing functionality
                    newUrl = isThreeThingsEnabled ? cqArticleService.getUrl(storyViewIndex -1) : isRegional ? path : '';
                    parselyService.passingUrl(newUrl, storyViewIndex, 'scroll');

                    $location.url(newUrl).state({storyIndex: storyViewIndex});
                    $location.replace(newUrl);

                    //need to call for pushstate to start immediately
                    $scope.$apply();

                    //Load Social Bars for the new rendered story
                    SocialBarLoader();
                    // FSCOM-12270 - set "More Videos" link parse.ly tracking 
                    LinkTracking.setLinkTracking(document.querySelectorAll('.more-video > a.fs-more-btn'),'parsely',{
                        'utm_campaign'  : 'more_videos',
                        'utm_medium'    : 'fscom',
                        'utm_content'   : 'morelink'
                    });
                    LinkTracking.setLinkTracking(document.querySelectorAll('.fs-more-content > .fs-card-container > .fs-card'),'parsely',{
                        'utm_campaign'  : 'more_videos',
                        'utm_medium'    : 'fscom',
                        'utm_content'   : 'gallerytile'
                    });
                    videoUtils.setVideoDetailsToggle();
                    
                    /*
                     * The first story on the three things is rendered on page load.
                     * When the storyViewIndex is changed to 1 meaning users scroll
                     * from  original story to the first story on the 3 things,
                     * we fetch and render the second story on the 3 things.
                     * When the storyViewIndex is changed to 2 meaning users scroll
                     * to the second story on the 3 things (third story on the page),
                     * we fetch and render the third story (last story) on the 3 things.
                     */

                    if(isThreeThingsEnabled) {
                        if(storyViewIndex < 3){

                            if(!cqArticleService.articles[storyViewIndex].isFetched && !cqArticleService.articles[storyViewIndex].isFetching) {
                                cqArticleService.fetchArticle(storyViewIndex).then(function () {
                                    cqArticleService.renderArticle(storyViewIndex);
                                });
                            }
                        }
    
                        storyEvents.onPageChanged(storyViewIndex + 1, cqArticleService.getMetadata(storyViewIndex -1), false);
                    } 


                } else {
                    //apply updates if it is the original story
                    newUrl = originalPath;
                    $location.url(newUrl).state({storyIndex: storyViewIndex});
                    $scope.$apply()

                    storyEvents.onPageChanged(storyViewIndex + 1, originalMetadata, false);
                }

                //somehow this has to be called because the angular digest is not fully done.
                $rootScope.$apply();

                return newUrl;

            };

        }]);



// WEBPACK FOOTER //
// ./assets/components/threethings/controllers/storyCtrl.js